import { BaseStore } from 'fluxible/addons';

export default class UserStore extends BaseStore {
    constructor(dispatcher) {
        super(dispatcher);
        this.loggedIn = false;
        this.language = null;
        this.isAuthModalHidden = true;
    }

    load({ isLoggedIn = false, language = null }) {
        this.loggedIn = isLoggedIn;
        this.language = language;

        this.emitChange();
    }

    isLoggedIn() {
        return this.loggedIn;
    }

    getLanguage() {
        return this.language;
    }

    dismissAuthModal() {
        this.isAuthModalHidden = true;

        this.emitChange();
    }

    showAuthModal() {
        this.isAuthModalHidden = false;

        this.emitChange();
    }

    isAuthModalVisible() {
        return !this.loggedIn && !this.isAuthModalHidden;
    }
}

UserStore.storeName = 'UserStore';

UserStore.handlers = {
    LOAD_USER_DATA: 'load',
    DISMISS_AUTH_MODAL: 'dismissAuthModal',
    SHOW_AUTH_MODAL: 'showAuthModal',
};



// WEBPACK FOOTER //
// ./js/launch/stores/UserStore.js